import React from "react";
import GreenCards from "./GreenCards";
import PageBottomButton from "./PageBottomButton";
import PersonalInfo from "./PersonalInfo";
import EmailAndPhone from "./PhoneAndEmail";
import { ToastContainer } from "react-toastify";
import { actions } from "../../Auth/_redux/authRedux";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../CrudAndRedux/ProfileCrud";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const Profile = () => {
  const [isLoaded, setIsLoaded] = React.useState("0");

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  React.useEffect(() => {
    setIsLoaded("0");
    getUserProfile(authState.user.token)
      .then((res) => {
        setIsLoaded("1");
        dispatch(actions.setUserInfo(res.data.data));
      })
      .catch(() => {
        setIsLoaded("-1");
      });
  }, []);

  const jsxReturner = () => {
    switch (isLoaded) {
      case "-1":
        return (
          <h4 className="container" style={{ marginTop: "2rem" }}>
            مشکلی در دریافت اطلاعات بوجود آمد
          </h4>
        );
      case "0":
        return (
          <div className="container">
            <SkeletonTheme
              baseColor="#d9dce6"
              className="container"
              highlightColor="darkgray"
            >
              <Skeleton
                count={1}
                style={{
                  height: "10rem",
                  width: "100%",
                  marginBlock: 10,
                  borderRadius: 13,
                }}
              />

              <Skeleton
                count={1}
                style={{
                  height: "10rem",
                  width: "100%",
                  marginBlock: 10,
                  borderRadius: 13,
                }}
              />

              <Skeleton
                count={1}
                style={{
                  height: "10rem",
                  width: "100%",
                  marginBlock: 10,
                  borderRadius: 13,
                }}
              />
              <Skeleton
                count={1}
                style={{
                  height: "10rem",
                  width: "100%",
                  marginBlock: 10,
                  borderRadius: 13,
                }}
              />
            </SkeletonTheme>
          </div>
        );
      case "1":
        return (
          <>
            {" "}
            <GreenCards />
            <PersonalInfo />
            <EmailAndPhone />
            <PageBottomButton />
          </>
        );
    }
  };

  return (
    <div className="p-5">
      <ToastContainer style={{ fontFamily: "sans" }} rtl={true} />
      {jsxReturner()}
    </div>
  );
};

export default Profile;
